export default class CopyController {
  constructor(game, xml, levelDialogue) {
    this.copy = {};
    this.game = game;
    this.levelDialogue = levelDialogue;
    let nodes = xml.getElementsByTagName('item');
    for (let i = 0; i < nodes.length; i++) {
      this.copy[nodes[i].getAttribute('id')] = nodes[i].childNodes[0].nodeValue;
    }
  }

  getCopy(copy_id) {
    return this.copy[copy_id] || 'copy not found [ ' + copy_id + ' ]';
  }

  getCopyNoDefault(copy_id) {
    return this.copy[copy_id] || null;
  }

  getHowToPlayCopy() {
    let page = 0;
    const results = [];
    while (page < 3) {
      const title = this.copy['howtoplay_' + (page + 1) + '_title'];
      const copy = this.copy['howtoplay_' + (page + 1) + '_copy'];
      results.push({ title, copy });
      page++;
    }
    return results;
  }

  getLocationName(locationid, shortened) {
    if (shortened) {
      return this.getCopy(locationid.toLowerCase() + '_short');
    }
    return this.getCopy(locationid.toLowerCase() + '_long');
  }

  getPollQuestion(locationid) {
    return this.getCopy('poll_' + locationid.toLowerCase() + '_question');
  }
}



// WEBPACK FOOTER //
// ./js/app/controller/CopyController.js